import {
  SET_LOADING,
  UNSET_LOADING,
  SET_RESPONSE,
  OPEN_RESPONSE_MODAL,
  CLOSE_RESPONSE_MODAL,
  ERROR,
  SET_SUCCESS_MODAL,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  SET_BENEFITS_MODAL,
  FACILITY_CLAIMS,
} from "./actionTypes";

export const setLoader = () => ({ type: SET_LOADING });

export const unSetLoader = () => ({ type: UNSET_LOADING });

export const setErrorMessage = (message) => ({
  type: ERROR,
  payload: true,
  data: message,
});

export const showResponseModal = () => ({
  type: OPEN_RESPONSE_MODAL,
  payload: true,
});

export const clearResponseModal = () => ({
  type: CLOSE_RESPONSE_MODAL,
});

export const setResponse = (payload) => ({
  type: SET_RESPONSE,
  payload,
});

export const setSuccessModal = (payload) => ({
  type: SET_SUCCESS_MODAL,
  payload,
});

export const showSnackbar = (message, duration = 3000) => ({
  type: SHOW_SNACKBAR,
  message,
  duration,
});

export const clearSnackbar = () => ({
  type: HIDE_SNACKBAR,
});
export const setBenefitsModal = (value) => {
  return {
    type: SET_BENEFITS_MODAL,
    payload: value,
  };
};

export const setFacilityClaims = (data) => {
  return {
    type: FACILITY_CLAIMS,
    payload: data,
  };
};
